const requireLocale = require.context('./', false, /\.json$/)

export const locales = requireLocale.keys().reduce((locales, path) => {
	const key = path.replace('./', '').replace('.json', '')
	locales[key] = requireLocale(path)
	return locales
}, {})
